import React from 'react';
import { render } from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store";
import 'bootstrap/dist/css/bootstrap.css';
import * as serviceWorker from './serviceWorker';
import App from "./App.SA";
import configureApiRestService from './services/apiservice';
import './components/Questions/Steps/Animation.css';
import { removeloginCookie } from '../src/components/User/Auth';
import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';

require('./index_' + process.env.REACT_APP_CODE_TENANT + '.css');
removeloginCookie();
configureApiRestService();

const store = configureStore();

const Root = () => (
  <Provider store={store}>
    <ClearBrowserCacheBoundary auto>
      <App />
    </ClearBrowserCacheBoundary>
  </Provider>
);

render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
